"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const constants_1 = require("../../../constants");
const react_bootstrap_1 = require("react-bootstrap");
const CompanyInfo_1 = require("./CompanyInfo");
const LoadingSpinner_1 = require("../../../shared/LoadingSpinner");
const DocumentTitle = require("react-document-title");
class Feedback extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            state: constants_1.ProgressState.Loading
        };
    }
    render() {
        let content;
        switch (this.state.state) {
            case constants_1.ProgressState.Loading:
                content = React.createElement(LoadingSpinner_1.default, { key: "Feedback.Page.LoadingSpinner" });
                break;
            case constants_1.ProgressState.Success:
                content = this.feedbackMessage();
                break;
            case constants_1.ProgressState.Failed:
                content = this.failedFeedbackMessage();
                break;
        }
        return React.createElement("div", { className: "feedback-page" }, React.createElement(DocumentTitle, { title: "Feedback" }), content);
    }
    feedbackMessage() {
        return React.createElement("div", { className: "feedback-landing-main" }, React.createElement(CompanyInfo_1.default, { data: { name: this.state.businessName } }), React.createElement(react_bootstrap_1.Clearfix, null));
    }
    failedFeedbackMessage() {
        return React.createElement("div", { className: "feedback-landing-main" }, React.createElement(CompanyInfo_1.default, { data: { name: this.state.businessName } }));
    }
}
exports.default = Feedback;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/feedback/component/Feedback.tsx
// module id = 1355
// module chunks = 1